export enum TasksColumnSizes {
  Checkbox = 4,
  Description = 29,
  ApplicationId = 15,
  BorrowerName = 16,
  TeamMembers = 17,
  DueDate = 19,
}
